import React from 'react'
import propTypes from 'prop-types'

/**
 * @desc About GIVU information
 */
const AboutGivu = ({type}) => {
  switch (type) {
    case '1':
      return type01()
    case '2':
      return type02()
    default:
      return type01()
  }
}

const type01 = () => {
  return (
    <div className='w-full border rounded-sm flex text-[#333333] mb-10 shadow-md'>
      <div className='w-fit p-6'>
        <h3 className='text-2xl w-fit font-bold font-serif'>GIVU</h3>
      </div>
      <div className='text-sm p-3'>
        <p>
          Lorem ipsum dolor, sit amet consectetur adipisicing elit.
          <br /> Quam esse perferendis quibusdam.
          <br />
          Ad placeat voluptates porro sit molestias, temporibus ratione, rem, voluptatem quaerat
          magni fugit natus. <br /> Incidunt possimus dolorum voluptatum.
        </p>
      </div>
    </div>
  )
}

const type02 = () => {
  return (
    <div className='w-full shadow-md border-none flex justify-center py-20 text-[#333333]'>
      <div className='flex max-w-7xl justify-center min-w-fit'>
        <div className='w-fit h-full pl-12 pr-8 pt-4 flex'>
          <h3 className='text-6xl w-fit font-bold font-serif justify-start'>GIVU</h3>
        </div>
        <div className='text-lg p-3'>
          <p>
            Here at Givu, we want to make the world just a bit better. <br />
            Our small team is still hard at work to make this happen, so be sure to check back soon. <br />
            If you&apos;d like to help change the world, reach out to us! <br />
            You can reach is via email at <a href='mailto:andy.lee@givu.us'>andy.lee@givu.us</a>
          </p>
        </div>
      </div>
    </div>
  )
}

AboutGivu.propTypes = {
  type: propTypes.string.isRequired
}

export default AboutGivu
